import { gcApi } from 'config/axios';
import {
    REQUEST_ACTIVITY_TYPES,
    RECEIVE_ACTIVITY_TYPES,
    REQUEST_ACTIVITY_HR_TIME_IN_ZONE,
    RECEIVE_ACTIVITY_HR_TIME_IN_ZONE,
    REQUEST_ACTIVITY_POWER_TIME_IN_ZONE,
    RECEIVE_ACTIVITY_POWER_TIME_IN_ZONE,
    REQUEST_ACTIVITY,
    RECEIVE_ACTIVITY,
    RECEIVE_MULTIPLE_ACTIVITIES,
    REQUEST_MULTIPLE_ACTIVITIES,
    REQUEST_CHARTS_ORDER,
    FETCH_ACTIVITY,
    FETCH_MULTIPLE_ACTIVITIES,
    RESET_ACTIVITY,
    RECEIVE_SEGMENT_ACTIVITY,
    FETCH_CHARTS_ORDER
} from './ActionTypes';

/**
 * ACTIVITY
 */
export const FETCH_ACTIVITIES_QUERY = 'FETCH_ACTIVITIES_QUERY';
export const FETCH_ACTIVITIES_QUERY_FETCHING = 'FETCH_ACTIVITIES_QUERY_FETCHING';
export const FETCH_ACTIVITIES_QUERY_SUCCESS = 'FETCH_ACTIVITIES_QUERY_SUCCESS';
export const FETCH_ACTIVITIES_QUERY_FAIL = 'FETCH_ACTIVITIES_QUERY_FAIL';

const requestActivityTypes = () => ({
    type: REQUEST_ACTIVITY_TYPES
});

const receiveActivityTypes = (json) => ({
    type: RECEIVE_ACTIVITY_TYPES,
    activityTypes: json,
    receivedAt: Date.now()
});

export const fetchActivityTypes = (evictCache) => {
    return {
        type: REQUEST_ACTIVITY_TYPES,
        meta: {
            cacheTime: evictCache ? null : 3600000
        }
    };
};

export const requestActivityHrTimeInZones = (activityId) => ({
    type: REQUEST_ACTIVITY_HR_TIME_IN_ZONE,
    activityId
});

export const receiveActivityHrTimeInZones = (json, activityId) => ({
    type: RECEIVE_ACTIVITY_HR_TIME_IN_ZONE,
    activityHrTimeInZones: json,
    activityId,
    receivedAt: Date.now()
});

export const requestActivityPowerTimeInZones = (activityId) => ({
    type: REQUEST_ACTIVITY_POWER_TIME_IN_ZONE,
    activityId
});

export const receiveActivityPowerTimeInZones = (json, activityId) => ({
    type: RECEIVE_ACTIVITY_POWER_TIME_IN_ZONE,
    activityPowerTimeInZones: json,
    activityId,
    receivedAt: Date.now()
});

export const fetchActivities = (queryParams) => ({
    type: FETCH_ACTIVITIES_QUERY,
    queryParams: queryParams,
    receivedAt: Date.now()
});

export const createActivity = (url, data) => {
    return gcApi.post(`/activity-service/activity`, data);
};

export const updateActivity = (url, activityId, data) => {
    return gcApi.put(`/activity-service/activity/${activityId}`, data);
};

export const deleteActivity = (url, activityId) => {
    return gcApi.delete(`/activity-service/activity/${activityId}`);
};

export const getActivity = (activityId) => {
    return gcApi.get(`/activity-service/activity/${activityId}`);
};

export const requestActivity = (activityId) => ({
    type: REQUEST_ACTIVITY,
    activityId
});

export const receiveActivity = (json, activityId) => ({
    type: RECEIVE_ACTIVITY,
    activity: json,
    activityId,
    receivedAt: Date.now()
});

export const requestMultipleActivities = (activitiesIds) => ({
    type: REQUEST_MULTIPLE_ACTIVITIES,
    activitiesIds
});

export const receiveMultipleActivities = (activities) => ({
    type: RECEIVE_MULTIPLE_ACTIVITIES,
    activities: activities,
    receivedAt: Date.now()
});

export const receiveChartOrder = (chartsOrder) => ({
    type: REQUEST_CHARTS_ORDER,
    chartsOrder: chartsOrder,
    receivedAt: Date.now()
});

export const fetchActivity = (activityId, callback, evictCache = true) => ({
    type: FETCH_ACTIVITY,
    activityId,
    callback,
    meta: {
        cacheTime: evictCache ? null : 120000
    }
});

export const fetchMultipleActivities = (activitiesIds) => ({
    type: FETCH_MULTIPLE_ACTIVITIES,
    activitiesIds
});

export const resetActivity = () => {
    return { type: RESET_ACTIVITY };
};

export const receiveSegmentActivity = (json, activityId) => ({
    type: RECEIVE_SEGMENT_ACTIVITY,
    activity: json,
    activityId,
    receivedAt: Date.now()
});

export const fetchChartsOrder = () => {
    return {
        type: FETCH_CHARTS_ORDER
    };
};
